import { library } from '@fortawesome/fontawesome-svg-core'
import { faCompressArrowsAlt, faExpandArrowsAlt } from '@fortawesome/free-solid-svg-icons'
import { BrowserRouter as Router } from 'react-router-dom'
import './App.scss'
import './editorConfig'
import Toast from './components/Toast'
import AuthorizedContent from './layout/AuthorizedContent'
import CustomerView from './layout/CustomerView'
import { QueryClient, QueryClientProvider } from 'react-query'
import MinimizedHandlerAssignmentEmailWindows from './components/minimized-handler-assignment-email-windows/MinimizedHandlerAssignmentEmailWindows'

library.add(faExpandArrowsAlt, faCompressArrowsAlt)

const isCustomerView = process.env.REACT_APP_IS_CUSTOMER_VIEW === 'true'

const App = () => {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Toast />
        {isCustomerView && <CustomerView />}
        {!isCustomerView && <AuthorizedContent />}
      </Router>
      <MinimizedHandlerAssignmentEmailWindows />
    </QueryClientProvider>
  )
}

export default App
